import { UserFlagsDisplayFlag } from '@xing-com/crate-common-graphql-types';
import { capitalizeString } from '@xing-com/crate-entity-pages-common';
import { Flag } from '@xing-com/flag';

import { SocialProofListQuery } from '../../../graphql/queries/social-proof-list-query.gql-types';

import * as Styled from './social-proof-list.styles';

type SocialProofUser = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          Extract<
            SocialProofListQuery['entityPageEX'],
            { __typename?: 'EntityPage' }
          >
        >['userPageContext']
      >['socialProof']
    >['edges'][number]
  >['node']
>;

type Props = {
  user: SocialProofUser;
};
export const SocialProofItem: React.FC<Props> = ({ user }) => {
  const displayFlag = user.xingId?.userFlags?.displayFlag;
  const showFlag =
    displayFlag !== UserFlagsDisplayFlag.Basic &&
    displayFlag !== UserFlagsDisplayFlag.Executive;

  return (
    <Styled.ListItem data-testid="social-proof-contact">
      <Styled.ProfileInfo
        key={user.xingId?.id}
        profileUrl={
          user?.xingId?.clickReasonProfileUrl?.profileUrl ||
          `/profile/${user.xingId?.pageName}`
        }
        profileImage={{
          size: 'small',
          src: user.xingId?.profileImage?.[0]
            ? user.xingId?.profileImage[0].url
            : undefined,
          profileName: 'user profile image',
        }}
        headline={{
          size: 'small',
          children: (
            <div>
              <strong>{user.xingId?.displayName}</strong>
              {displayFlag && showFlag && (
                <Flag
                  size="small"
                  // @ts-expect-error ignore
                  variant={displayFlag.toLowerCase()}
                >
                  {capitalizeString(displayFlag)}
                </Flag>
              )}
            </div>
          ),
        }}
        textBody={[
          {
            size: 'small',
            children: user.xingId?.occupations?.[0]?.headline,
          },
        ]}
        textMeta={[
          {
            size: 'small',
            children: user.xingId?.occupations?.[0]?.subline,
          },
        ]}
      />
    </Styled.ListItem>
  );
};
